import { render } from "./charts-table-wrapper.vue?vue&type=template&id=72ed547d&ts=true"
import script from "./charts-table-wrapper.vue?vue&type=script&lang=ts"
export * from "./charts-table-wrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__